import axios from "axios";
import { IMPORT_PROJECT_CONFIGURATION_URL, PREVIEW_PROJECT_CONFIGURATION_IMPORT_URL } from "@/utils/constants/constants.js";

function parse_response_data(response_data) {
  return typeof response_data === "string" ? JSON.parse(response_data) : response_data;
}

export default {
  methods: {
    async preview_project_configuration() {
      this.import_preview = null;
      this.import_form_ids = [];
      this.import_template_ids = [];
      if (!this.import_source_project_id) return;

      this.import_preview_loading = true;
      try {
        const response = await axios.get(PREVIEW_PROJECT_CONFIGURATION_IMPORT_URL, {
          headers: this.headers,
          params: { source_project_id: this.import_source_project_id, target_project_id: 0 },
        });
        this.import_preview = parse_response_data(response.data)?.data || null;
      } catch {
        const source = this.company_list.find((item) => String(item.id) === String(this.import_source_project_id));
        this.import_preview = source ? { forms: [], templates: [], source_project: { name: source.name } } : null;
      } finally {
        this.import_preview_loading = false;
      }
    },
    async import_project_configuration(target_project_id) {
      const source_project_id = Number(this.import_source_project_id || 0);
      if (!source_project_id) return;

      const preview_response = await axios.get(PREVIEW_PROJECT_CONFIGURATION_IMPORT_URL, {
        headers: this.headers,
        params: { source_project_id, target_project_id },
      });
      const preview = parse_response_data(preview_response.data)?.data || {};
      const form_ids = this.import_form_ids.length ? this.import_form_ids : (preview.forms || []).filter((item) => !item.conflict).map((item) => item.id);
      const template_ids = this.import_template_ids.length ? this.import_template_ids : (preview.templates || []).filter((item) => !item.conflict).map((item) => item.id);
      if (!form_ids.length && !template_ids.length) return;

      const result = await axios.post(IMPORT_PROJECT_CONFIGURATION_URL, {
        source_project_id,
        target_project_id,
        form_ids,
        template_ids,
      }, { headers: this.headers });
      const summary = parse_response_data(result.data)?.data?.summary || {};
      const failed = [...(summary.forms || []), ...(summary.templates || [])].filter((item) => item.status === "failed");
      if (failed.length) this.show_info(`Programme created; ${failed.length} configuration item(s) need attention.`);
      else this.show_success("Programme configuration imported successfully.");
    },
  },
};
